// Reactive media-query hook — returns true when viewport ≤ breakpoint.
// One-line wrapper around window.matchMedia + a React state subscription.
// Default breakpoint: 768px, matching Tailwind's `md` / the SiteHeader's
// hamburger threshold so all responsive switches happen at the same width.

import { useEffect, useState } from 'react';

export function useIsMobile(breakpointPx = 768): boolean {
  const [isMobile, setIsMobile] = useState<boolean>(() =>
    typeof window !== 'undefined' ? window.innerWidth <= breakpointPx : false,
  );

  useEffect(() => {
    if (typeof window === 'undefined') return;
    const mq = window.matchMedia(`(max-width: ${breakpointPx}px)`);
    const fn = (e: MediaQueryListEvent | MediaQueryList): void =>
      setIsMobile(e.matches);
    fn(mq);
    mq.addEventListener('change', fn);
    return () => mq.removeEventListener('change', fn);
  }, [breakpointPx]);

  return isMobile;
}
